// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vang Pham (ptvang@rsupport.com)
 *
 * @description
 *
 * @created at Mon Sep 09 2024
 **/

import { forwardRef, Ref } from "react";
import { IconProps } from "../Icon";
import Svg from "@/frameworks/designStuff/components/Contents/Icon/Svg";
const Share3DExtension = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy: string | undefined = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 36 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<rect width="36" height="36" rx="8" fill="#7F86F3" />
				<g clipPath="url(#clip0_5846_65386)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M26.8799 11.7688L19.4828 8.06589C18.5485 7.60304 17.4514 7.60304 16.5171 8.06589L9.11993 11.7688C7.99707 12.3259 7.28564 13.4745 7.28564 14.7345V21.9688C7.28564 23.2202 7.99707 24.3688 9.11993 24.9345L16.5256 28.6373C17.4599 29.1002 18.5571 29.1002 19.4914 28.6373L26.8971 24.9345C28.0199 24.3773 28.7314 23.2288 28.7314 21.9688V14.7345C28.7314 13.483 28.0199 12.3345 26.8971 11.7688H26.8799ZM17.2714 9.57446C17.7256 9.34304 18.2656 9.34304 18.7199 9.57446L25.3628 12.8916L17.9828 16.5773L10.3628 13.0287L17.2714 9.57446ZM9.87422 23.4088C9.32564 23.1345 8.97422 22.5688 8.97422 21.9602V14.7259C8.97422 14.5716 8.99993 14.4173 9.04279 14.2716L17.1599 18.0602V27.0602L9.87422 23.4173V23.4088ZM27.0256 18.7288V21.9602C27.0256 22.5773 26.6742 23.1345 26.1256 23.4088L18.8399 27.0516V18.0345L26.8542 14.0316C26.9571 14.2459 27.0256 14.4773 27.0256 14.7259V18.7288Z"
						fill="white"
					/>
				</g>
				<defs>
					<clipPath id="clip0_5846_65386">
						<rect width="21.4286" height="21.2571" fill="white" transform="translate(7.28564 7.71436)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
Share3DExtension.defaultProps = {
	size: 36,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default Share3DExtension;
